module.exports = __webpack_public_path__ + "static/media/Thumbnail-shristi-ko-geet-part-two.36cbc27d.png";